import React from 'react';
import { useEvent } from 'react-use';
import { auth } from '@gik/auth';

// do NOT migrate this to NextJS.
// it only exist to capture Razor template/outside of React requests to open the auth dialogs.
// and will be removed as soon as not needed anymore.
// TODO: once no Razor template needs to trigger login anymore, remove this and the functions on window defined on MVC
export default function AuthContainer() {
  useEvent('LoginOrSignUpModal', ev => {
    if (ev.detail.open) {
      auth.loginOrSignup();
    }
  });

  useEvent('LoginModal', ev => {
    if (ev.detail.open) {
      auth.login();
    }
  });

  useEvent('ResetPasswordModal', ev => {
    if (ev.detail.open) {
      auth.resetPassword();
    }
  });

  return (
    <div
      id="auth-container"
      style={{
        position: 'absolute',
        left: -999999,
        top: -999999,
      }}
    />
  );
}
